/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { SidebarMenuItem } from './SidebarMenuItem'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { useAuth } from '../../../../../app/modules/auth'
import { PermissionName } from '../../../../../app/modules/auth/core/_permission'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const { currentUser } = useAuth();
  const permissions = currentUser?.result?.permissions;
  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />
      {
        permissions?.some(x => x.name === PermissionName.GraduatedPanel) ?
          <>
            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted fs-8 ls-1'>{intl.formatMessage({id: 'SIDE.GRADUATED'})}</span>
              </div>
            </div>
            <SidebarMenuItemWithSub
              to='/graduation-panel'
              title={intl.formatMessage({id: 'SIDE.GRADUATED'})}
              fontIcon='bi-archive'
              icon='teacher'
            >
              <SidebarMenuItem to='/graduation-panel/jobs' title={intl.formatMessage({id: 'SIDE.GRADUATED.JOBADVERT'})} hasBullet={true} />
              <SidebarMenuItem to='/graduation-panel/is-basvurularim' title={intl.formatMessage({id: 'SIDE.GRADUATED.JOBAPPLICATION'})} hasBullet={true} />
              <SidebarMenuItem to='/graduation-panel/attachments' title={intl.formatMessage({id: 'SIDE.GRADUATED.ATTACHMENT'})} hasBullet={true} />
              <SidebarMenuItem to='/graduation-panel/card-requests' title={intl.formatMessage({id: 'SIDE.GRADUATED.CARDREQUEST'})} hasBullet={true} />
              <SidebarMenuItem to='/graduation-panel/my-career' title={intl.formatMessage({id: 'SIDE.GRADUATED.MYCAREER'})} hasBullet={true} />
            </SidebarMenuItemWithSub>
          </> : <></>
      }
      {
        permissions?.some(x => x.name === PermissionName.MyCompanyManage || x.name === PermissionName.JobAdvert) ?
          <>
            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted fs-8 ls-1'>{intl.formatMessage({id: 'SIDE.COMPANY'})}</span>
              </div>
            </div>
            <SidebarMenuItemWithSub
              to='/company-panel'
              title={intl.formatMessage({id: 'SIDE.COMPANY'})}
              fontIcon='bi-archive'
              icon='chart-pie-3'
            >
              {
                permissions?.some(x => x.name === PermissionName.MyCompanyManage) ?
                  <SidebarMenuItem to='/company-panel/companies' title={intl.formatMessage({id: 'SIDE.COMPANY.MYCOMPANY'})} hasBullet={true} /> :<></>
                }
              {
                permissions?.some(x => x.name === PermissionName.JobAdvert) ?
                  <>
                    <SidebarMenuItem to='/company-panel/my-job-ads' title={intl.formatMessage({id: 'SIDE.COMPANY.JOBADVERT'})} hasBullet={true} /> 
                  </>:<></>
              
              }
              {
                permissions?.some(x => x.name === PermissionName.ApplicationReview) ?
                  <>
                    <SidebarMenuItem to='/company-panel/job-applications' title={intl.formatMessage({id: 'SIDE.COMPANY.APPLICATIONS'})} hasBullet={true} /> 
                  </>:<></>
              
              }
            </SidebarMenuItemWithSub>
          </> : <></>
      }
      {
        permissions?.some(x => x.name === PermissionName.PDPL) ?
          <>
            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted fs-8 ls-1'>{intl.formatMessage({id: 'SIDE.SETINGS'})}</span>
              </div>
            </div>
            <SidebarMenuItemWithSub
              to='/admin-panel'
              title={intl.formatMessage({id: 'SIDE.SETINGS.MANAGEMENTS'})}
              fontIcon='bi-archive'
              icon='note-2'
            >
              <SidebarMenuItem to='/admin-panel/kvkk-job' title={intl.formatMessage({id: 'SIDE.SETINGS.MANAGEMENTS.PDPL.JOB'})} hasBullet={true} />
              <SidebarMenuItem to='/admin-panel/kvkk-register' title={intl.formatMessage({id: 'SIDE.SETINGS.MANAGEMENTS.PDPL.REGISTER'})} hasBullet={true} />
            </SidebarMenuItemWithSub>
          </> : <></>
      }
      {
        permissions?.some(x => x.name === PermissionName.Graduated || x.name === PermissionName.Card) ?
          <>
            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted fs-8 ls-1'>{intl.formatMessage({id: 'SIDE.GRADUATEDINFORMATION'})}</span>
              </div>
            </div>

            <SidebarMenuItemWithSub
              to='/graduation-system'
              title={intl.formatMessage({id: 'SIDE.GRADUATEDINFORMATION.TITLE'})}
              fontIcon='element-plus'
              icon='teacher'
            >
              {
                permissions?.some(x => x.name === PermissionName.Graduated) ?
                  <SidebarMenuItem to='/graduation-system/graduates' title={intl.formatMessage({id: 'SIDE.GRADUATEDINFORMATION.GRADUATES'})} hasBullet={true} /> : <></>
              }
              {
                permissions?.some(x => x.name === PermissionName.Card) ?
                  <SidebarMenuItem to='/graduation-system/cards' title={intl.formatMessage({id: 'SIDE.GRADUATEDINFORMATION.CARDS'})} hasBullet={true} /> : <></>
              }
            </SidebarMenuItemWithSub>
          </> : <></>
      }
      {
        permissions?.some(x => x.name === PermissionName.CompanyMonitoring || x.name === PermissionName.JobMonitoring || x.name === PermissionName.ApplicationMonitoring) ?
          <>
            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted fs-8 ls-1'>{intl.formatMessage({id: 'SIDE.COMPANYSUPERVISION'})}</span>
              </div>
            </div>

            <SidebarMenuItemWithSub
              to='/company-and-jobs'
              title={intl.formatMessage({id: 'SIDE.COMPANYMONITORING.TITLE'})}
              fontIcon='bi-archive'
              icon='chart-pie-simple'
            >
              {
                permissions?.some(x => x.name === PermissionName.CompanyMonitoring) ?
                  <SidebarMenuItem to='/company-and-jobs/companies' title={intl.formatMessage({id: 'SIDE.COMPANYMONITORING.COMPANY'})} hasBullet={true} /> : <></>}
              {
                permissions?.some(x => x.name === PermissionName.JobMonitoring) ?
                  <SidebarMenuItem to='/company-and-jobs/jobs' title={intl.formatMessage({id: 'SIDE.COMPANYMONITORING.JOBADVERT'})} hasBullet={true} /> : <></>}
              {
                permissions?.some(x => x.name === PermissionName.ApplicationMonitoring) ?
                  <SidebarMenuItem to='/company-and-jobs/applications' title={intl.formatMessage({id: 'SIDE.COMPANYMONITORING.APPLICATIONS'})} hasBullet={true} /> : <></>}
            </SidebarMenuItemWithSub>
          </> : <></>}

      {
        permissions?.some(x => x.name === PermissionName.EmailSend || x.name === PermissionName.EmailTemplate || x.name === PermissionName.EmailHistory) ?
          <>
            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted fs-8 ls-1'>{intl.formatMessage({id: 'SIDE.EMAIL'})}</span>
              </div>
            </div>
            <SidebarMenuItemWithSub
              to='/send-email-system'
              title={intl.formatMessage({id: 'SIDE.EMAIL'})}
              fontIcon='bi-archive'
              icon='sms'
            >
              {
                permissions?.some(x => x.name === PermissionName.EmailSend) ?
                  <SidebarMenuItem
                    to='/send-email-system/send-email'
                    title={intl.formatMessage({id: 'SIDE.EMAIL.SEND'})}
                    hasBullet={true}
                  /> : <></>}
              {
                permissions?.some(x => x.name === PermissionName.EmailTemplate) ?
                  <SidebarMenuItem
                    to='/send-email-system/email-template'
                    title={intl.formatMessage({id: 'SIDE.EMAIL.TEMPLATE'})}
                    hasBullet={true}
                  /> : <></>}
              {
                permissions?.some(x => x.name === PermissionName.EmailHistory) ?
                  <SidebarMenuItem
                    to='/send-email-system/email-history'
                    title={intl.formatMessage({id: 'SIDE.EMAIL.HISTORY'})}
                    hasBullet={true}
                  /> : <></>}
            </SidebarMenuItemWithSub>
          </> : <></>}

      {
        permissions?.some(x => x.name === PermissionName.NewsCreate) ?
          <>
            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted fs-8 ls-1'>{intl.formatMessage({id: 'SIDE.NEWS'})}</span>
              </div>
            </div>
            <SidebarMenuItemWithSub
              to='/news-module'
              title={intl.formatMessage({id: 'SIDE.NEWS'})}
              fontIcon='bi-archive'
              icon='messages'
            >
              <SidebarMenuItem
                to='/news-module/news-creation'
                title={intl.formatMessage({id: 'SIDE.NEWS.DEFINITION'})}
                hasBullet={true}
              />
            </SidebarMenuItemWithSub>
          </> : <></>}
      {
        permissions?.some(x => x.name === PermissionName.Users || x.name === PermissionName.Roles) ?
          <>
            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted fs-8 ls-1'>{intl.formatMessage({id: 'SIDE.USER'})}</span>
              </div>
            </div>

            <SidebarMenuItemWithSub
              to='/user-definitions'
              title={intl.formatMessage({id: 'SIDE.USER'})}
              fontIcon='bi-archive'
              icon='user-square'
            >
              {
                permissions?.some(x => x.name === PermissionName.Users) ?
                  <SidebarMenuItem
                    to='/user-definitions/users'
                    title={intl.formatMessage({ id: 'MENU.USER' })}
                    hasBullet={true}
                  /> : <></>}
              {
                permissions?.some(x => x.name === PermissionName.Roles) ?
                  <SidebarMenuItem
                    to='/user-definitions/roles'
                    title={intl.formatMessage({ id: 'MENU.ROLE' })}
                    hasBullet={true}
                  /> : <></>}
              {
                permissions?.some(x => x.name === PermissionName.Address) ?
                  <SidebarMenuItem
                    to='/user-definitions/addresses'
                    title='Adres'
                    hasBullet={true}
                  /> : <></>}
            </SidebarMenuItemWithSub>
          </> : <></>}
      {
        permissions?.some(x => x.name === PermissionName.University) ?
          <>
            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted fs-8 ls-1'>
                  {intl.formatMessage({ id: 'SIDE.UNIVERSITY' })}
                </span>
              </div>
            </div>
            <SidebarMenuItemWithSub
              to='/system-definitions'
              title={intl.formatMessage({ id: 'SIDE.UNIVERSITY' })}
              fontIcon='bi-archive'
              icon='setting-3'
            >
              <SidebarMenuItem
                to='/system-definitions/universities'
                title='Üniversite'
                hasBullet={true}
              />
              <SidebarMenuItem to='/system-definitions/faculties' title='Fakülte' hasBullet={true} />
              <SidebarMenuItem to='/system-definitions/departments' title='Departman' hasBullet={true} />
              <SidebarMenuItem
                to='/system-definitions/sub-departments'
                title='Alt Departman'
                hasBullet={true}
              />
              <SidebarMenuItem
                to='/system-definitions/program-types'
                title='Program Tipi'
                hasBullet={true}
              />
              <SidebarMenuItem to='/system-definitions/programs' title='Program' hasBullet={true} />
            </SidebarMenuItemWithSub>
          </> : <></>}
      {
        permissions?.some(x => x.name === PermissionName.Location || x.name === PermissionName.Code) ?
          <>
            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted fs-8 ls-1'>
                  {intl.formatMessage({ id: 'SIDE.BASE_DEFINITIONS' })}
                </span>
              </div>
            </div>

            <SidebarMenuItemWithSub
              to='/base-definitions'
              title={intl.formatMessage({ id: 'SIDE.BASE_DEFINITIONS' })}
              fontIcon='bi-archive'
              icon='setting-3'
            >
              {
                permissions?.some(x => x.name === PermissionName.Location) ?
                  <>
                    <SidebarMenuItem to='/base-definitions/countries' title={'Ülke'} hasBullet={true} />
                    <SidebarMenuItem to='/base-definitions/provinces' title={'İl'} hasBullet={true} />
                    <SidebarMenuItem to='/base-definitions/districts' title={'İlçe'} hasBullet={true} />
                  </> : <></>}
              {
                permissions?.some(x => x.name === PermissionName.Code) ?
                  <>
                    <SidebarMenuItem
                      to='/base-definitions/code-groups'
                      title={'Kod Grupları'}
                      hasBullet={true}
                    />
                    <SidebarMenuItem to='/base-definitions/codes' title={'Kodlar'} hasBullet={true} />
                  </> : <></>}
            </SidebarMenuItemWithSub>
          </> : <></>}
    </>
  )
}

export { SidebarMenuMain }
